module.exports = require('./helpers/bundle-url').getBundleURL('c00bE') + "logo-dark.eefe0b7f.svg";